const messages = {
    menuTitle: 'Zlecenia docięcia',
    pageTitle: 'Zlecenia docięcia',

    actions: {
        create: 'Nowe zlecenie',
        edit: 'Edytuj',
        printCard: 'Wygeneruj kartę PDF',
        delete: 'Usuń',
        generateReport: 'Generuj raport'
    },

    filters: {
        statusLabel: 'Status',
        channelLabel: 'Kanał',
        paperLabel: 'Rodzaj surowca',
        createdFromLabel: 'Zlecenie utworzone od',
        createdToLabel: 'Zlecenie utworzone do',
        noStatus: 'Nie znaleziono statusu',
        noChannel: 'Nie znaleziono kanału',
        noPaper: 'Nie znaleziono papieru'
    },

    table: {
        headers: {
            createdAt: 'Data',
            channel: 'Kanał',
            number: 'Numer zlecenia docięcia',
            objectNumber: 'Numer zlecenia',
            paper: 'Rodzaj surowca',
            inputFormat: 'Format wejściowy surowca',
            outputFormat: 'Format wyjściowy surowca',
            inputSheetsCount: 'Ilość arkuszy na wejściu',
            partsCount: 'Ilość użytków po krojeniu',
            inputSheetsWeight: 'Waga arkuszy na wejściu',
            outputSheetsWeight: 'Waga arkuszy na wyjściu',
            outputSheetsCount: 'Ilość arkuszy na wyjściu',
            wasteSheetsWeight: 'Waga odpadu',
            estimatedTime: 'Szacowany czas',
            status: 'Status',
            actions: 'Akcje'
        }
    },

    deleteDialog: {
        title: 'Usuwanie zlecenia docięcia',
        message: 'Czy na pewno chcesz usunąć zlecenie docięcia nr {number}?',
        confirmButton: 'Usuń'
    },

    dialog: {
        titleCreate: 'Tworzenie nowego zlecenia',
        titleEdit: 'Edycja zlecenia docięcia',
        buttons: {
            create: 'Utwórz',
            save: 'Zapisz'
        },
        fields: {
            channel: 'Kanał',
            objectNumber: 'Numer zlecenia',
            paper: 'Rodzaj surowca',
            rawMaterialName: 'Nazwa surowca',
            partsCount: 'Ilość użytków po krojeniu',
            inputFormatA: 'Format A na wejściu',
            inputFormatB: 'Format B na wejściu',
            outputFormatA: 'Format A na wyjściu',
            outputFormatB: 'Format B na wyjściu',
            inputSheetsCount: 'Ilość arkuszy na wejściu',
            weightInput: 'Waga na wejściu'
        },
        autocomplete: {
            noChannel: 'Nie znaleziono kanału',
            noJob: 'Nie znaleziono zlecenia',
            typeToSearch: 'Wpisz treść aby odnaleźć numer zlecenia.',
            minLength: 'Wpisz przynajmniej {min} znaki.',
            searching: 'Trwa wyszukiwanie numeru zlecenia...',
            notFound: 'Nie odnaleziono numeru zlecenia na zapytanie: "{query}".'
        }
    },

    validation: {
        channelRequired: 'Kanał jest wymagany.',
        objectNumberRequired: 'Numer zlecenia jest wymagany.',
        paperRequired: 'Rodzaj surowca jest wymagany.',
        partsCountRequired: 'Ilość użytków jest wymagana.',
        widthRequired: 'Szerokość jest wymagana.',
        valueMinOne: 'Wartość musi być większa niż 0.',
        valueInteger: 'Wartość musi być liczbą całkowitą.',
        valueNumeric: 'Wartość musi być liczbą.',
        valueDecimal: 'Wartość musi być liczbą.',
        requiredIfNoWeight: 'Wartość jest wymagana, jeśli nie podano wagi.',
        requiredIfNoSheets: 'Wartość jest wymagana, jeśli nie podano ilości arkuszy.',
        sheetsAndWeightExclusive: 'Nie można podać zarówno ilości arkuszy, jak i wagi.'
    },

    sentry: {
        create: 'Nowe zlecenie docięcia',
        edit: 'Edytuj zlecenie docięcia',
        printCard: 'Wygeneruj kartę PDF zlecenia docięcia',
        delete: 'Usuń zlecenie docięcia',
        generateReport: 'Generuj raport zleceń docięcia',
        cancelDialog: 'Anuluj dialog zlecenia docięcia',
        saveDialog: 'Zapisz zlecenie docięcia'
    },

    errors: {
        fetchList: 'Pobranie listy zleceń docięcia nie powiodło się.',
        generateReport: 'Generowanie raportu zleceń docięcia nie powiodło się.',
        fetchChannels: 'Pobranie listy kanałów docięcia nie powiodło się.',
        fetchStatuses: 'Pobranie listy statusów docięcia nie powiodło się.',
        fetchPapers: 'Pobranie listy papierów nie powiodło się.',
        fetchReportItems: 'Pobranie źródeł docięcia nie powiodło się.',
        printCard: 'Wydruk karty zlecenia docięcia nie powiódł się.',
        create: 'Utworzenie zlecenia docięcia nie powiodło się.',
        update: 'Aktualizacja zlecenia docięcia nie powiodła się.',
        delete: 'Wystąpił problem podczas usuwania zlecenia docięcia.'
    },

    notifications: {
        reportSuccess: 'Raport zostanie wygenerowany i przesłany na adres {email}.',
        createSuccess: 'Zlecenie zostało utworzone pomyślnie.',
        updateSuccess: 'Zlecenie zostało zaktualizowane pomyślnie.',
        deleteSuccess: 'Zlecenie docięcia zostało usunięte.'
    }
}

export default {
    messages,
    locale: 'pl'
}
